<H2>{{data.question | translate}}</H2>
<div class="confirm-delete">
    <mat-dialog-actions>
        <button mat-button [mat-dialog-close]="false">{{"shared.no" | translate}}</button>
        <button mat-button [mat-dialog-close]="true" data-testid="button-true">{{"shared.yes" | translate}}</button>
    </mat-dialog-actions>
</div>
